export default __webpack_public_path__ + "static/personaje3x2-5e0196b884933a8a0f6eb40690fa830c.png";